import { render, staticRenderFns } from "./rListFilterItem.vue?vue&type=template&id=4b96168c&scoped=true&"
import script from "./rListFilterItem.vue?vue&type=script&lang=js&"
export * from "./rListFilterItem.vue?vue&type=script&lang=js&"
import style0 from "./rListFilterItem.vue?vue&type=style&index=0&id=4b96168c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96168c",
  null
  
)

export default component.exports